/**
 * Fuel-refill API — mirrors `cargoCompanyDriver.js` mounted at
 * /api/cargo/me/company-driver/fuel-refills.
 *
 * Schema source of truth: `fuelRefillSchema` in
 * `server/routes/cargoCompanyDriver.js` (Joi).
 */
import { api } from './client';
import { unwrap } from './_unwrap';
import type { FuelRefill, CreateFuelRefillInput } from '@/types/companyExtras';

export const fuelRefillsApi = {
  async listMine(params?: { limit?: number; offset?: number }): Promise<FuelRefill[]> {
    const r = await api.get(`/api/cargo/me/company-driver/fuel-refills`, { params });
    return unwrap<FuelRefill[]>(r);
  },
  async create(input: CreateFuelRefillInput): Promise<FuelRefill> {
    const r = await api.post(`/api/cargo/me/company-driver/fuel-refills`, input);
    return unwrap<FuelRefill>(r);
  },
};
